import { ImageSource } from 'expo-image';
import { registerImages } from '@bonanza-social/moonlight';
import images from './images';

registerImages('wallet', images);

declare global {
  interface RegisteredImages {
    wallet: Record<keyof typeof images, ImageSource>;
  }
}
